import { Platform } from 'react-native';
import { OAUTH_SCHEME } from '@/lib/oauth/google-oauth';

type QueryParams = Record<string, string | undefined>;

export function getNativeAppScheme(): string {
  return process.env.EXPO_PUBLIC_NATIVE_APP_SCHEME?.trim() || OAUTH_SCHEME;
}

/**
 * Monta deep link do app nativo. Na web NÃO usar Linking.createURL — sem `scheme` ele
 * gera https://do-site/... e o Safari recarrega o site.
 */
export function buildNativeAppDeepLink(path: string, queryParams?: QueryParams): string {
  const scheme = getNativeAppScheme();
  const cleanPath = path.replace(/^\//, '');
  const qs = new URLSearchParams();

  if (queryParams) {
    for (const [key, value] of Object.entries(queryParams)) {
      if (value != null && value !== '') qs.set(key, value);
    }
  }

  const query = qs.toString();
  return query ? `${scheme}://${cleanPath}?${query}` : `${scheme}://${cleanPath}`;
}

/** Android Chrome: intent:// costuma abrir o app com mais confiabilidade que scheme puro. */
export function buildAndroidIntentDeepLink(path: string, queryParams?: QueryParams): string {
  const scheme = getNativeAppScheme();
  const cleanPath = path.replace(/^\//, '');
  const qs = new URLSearchParams();

  if (queryParams) {
    for (const [key, value] of Object.entries(queryParams)) {
      if (value != null && value !== '') qs.set(key, value);
    }
  }

  const query = qs.toString();
  const pathWithQuery = query ? `${cleanPath}?${query}` : cleanPath;
  const pkg = process.env.EXPO_PUBLIC_ANDROID_PACKAGE?.trim() || 'com.controlapag.app';

  return `intent://${pathWithQuery}#Intent;scheme=${scheme};package=${pkg};end`;
}

function isAndroidWeb(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /Android/i.test(navigator.userAgent);
}

/**
 * Abre o app a partir do browser. Evita Linking.openURL na web (pode virar navegação HTTPS).
 * Prefira <a href={url}> no JSX quando possível (gesto do usuário no Safari).
 */
export function navigateToNativeAppDeepLink(path: string, queryParams?: QueryParams): void {
  if (Platform.OS !== 'web' || typeof window === 'undefined') return;

  const schemeUrl = buildNativeAppDeepLink(path, queryParams);
  const url = isAndroidWeb()
    ? buildAndroidIntentDeepLink(path, queryParams)
    : schemeUrl;

  if (__DEV__) {
    console.log('[native-deep-link] navigate:', url);
  }

  window.location.href = url;
}
